import { CompareTableInterface } from '@adapters/bigcommerce/types/compareTable';

export function hasFranchiseCompareTable(
  table: CompareTableInterface | null | undefined
): boolean {
  return (
    table?.comparisonType === 'franchise' && (table.items?.length ?? 0) > 0
  );
}
